import client, { isRealApiEnabled } from "./client";

/**
 * @endpoint POST /api/v1/media  (multipart/form-data)
 * @returns {Promise<MediaAsset>}
 */
export function upload(file) {
  if (!file) {
    // Mirror the backend, which 400s on an empty upload, instead of fabricating
    // a fake media asset — the old guard ran before the isRealApiEnabled() check
    // and so returned bogus "success" even in real-API mode without ever hitting
    // the server.
    return Promise.reject(new Error("No file provided."));
  }
  if (isRealApiEnabled()) {
    const formData = new FormData();
    formData.append("file", file, file.name);
    return client.uploadFile("/v1/media", formData);
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      resolve({
        id: `med_new_${Date.now()}`,
        filename: file.name,
        url: e.target.result,
        mimeType: file.type,
        sizeBytes: file.size,
        width: null,
        height: null,
        uploadedAt: new Date().toISOString(),
      });
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
}
